import { createGenericReducer } from "common/genericReducer";
import {
  CONFIRM_DELETE_ACCOUNT_RECEIVED,
  CONFIRM_DELETE_ACCOUNT_REQUESTED,
  CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED,
  DELETE_ACCOUNT_RECEIVED,
  DELETE_ACCOUNT_REQUESTED,
  DELETE_ACCOUNT_REQUEST_FAILED,
  DELETE_ACCOUNT_REQUEST_RESET
} from "./deleteAccountActions";

export const deleteAccountRequest = createGenericReducer(
  DELETE_ACCOUNT_REQUESTED,
  DELETE_ACCOUNT_RECEIVED,
  DELETE_ACCOUNT_REQUEST_FAILED,
  DELETE_ACCOUNT_REQUEST_RESET
);

export const deleteAccountConfirmation = createGenericReducer(
  CONFIRM_DELETE_ACCOUNT_REQUESTED,
  CONFIRM_DELETE_ACCOUNT_RECEIVED,
  CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED
);
